import { render } from "./GesLibros.vue?vue&type=template&id=e2e85e50&scoped=true"
import script from "./GesLibros.vue?vue&type=script&lang=js"
export * from "./GesLibros.vue?vue&type=script&lang=js"

import "./GesLibros.vue?vue&type=style&index=0&id=e2e85e50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2e85e50"

export default script